export enum Cohort {
  V1 = "V1",
  V2 = "V2",
}

export const DEFAULT_COHORT = Cohort.V2;
